import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full flex rounded-sm text-center items-center" }
const _hoisted_2 = { class: "text-xs flex-row p-2 text-center flex" }
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.text_color,'text-[15px]']),
        textContent: _toDisplayString(_ctx.message)
      }, null, 10, _hoisted_3)
    ])
  ]))
}